import React from "react";
import ShowcaseItem from "../../items/ShowcaseItem";
import { useTranslation } from "react-i18next";

const Showcase = () => {
  const { t } = useTranslation();

  const caseData = [
    {
      caseTitle: t("Built For Dance Events Of All Sizes"),
      caseDescription: `
      <ul>
        <li>${t("Studios")}</li>
        <li>${t("Festivals")}</li>
        <li>${t("Championships")}</li>
        <li>${t("Showcases")}</li>
        <li>${t("Multi-location events")}</li>
      </ul>
    `,
    },
    {
      caseTitle: t("Trusted. Secure. Reliable."),
      caseDescription: `
      <ul>
        <li>${t("GDPR-compliant data handling")}</li>
        <li>${t("Encrypted cloud storage")}</li>
        <li>${t("24/7 support and onboarding help")}</li>
      </ul>
    `,
    },
    {
      caseTitle: t("Transparent Pricing with No Hidden Fees"),
      caseDescription: `
      <ul>
        <li>${t("No setup fees")}</li>
        <li>${t("No monthly commitments")}</li>
        <li>${t("Free for free-ticket events")}</li>
        <li>${t("Just £0.50 + VAT per paid ticket")}</li>
      </ul>
    `,
      caseInfo: t("Pay only when you sell"),
    },
  ];

  return (
    <section className="relative  bg-magnolia">
      <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto px-6">
        <h2 className="text-deep-purple text-2xl xl:text-3xl 2xl:text-4xl font-bold mb-5 xl:mb-8 2xl:mb-12">
          {t(
            "Whether you're hosting a local showcase or an international competition:"
          )}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 xl:gap-16 2xl:gap-24">
          {caseData.map((item, index) => (
            <ShowcaseItem key={index} data={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Showcase;
